import React, { useState, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import useScrollTransition from "../useScrollTransition";

// Component to animate numbers using setInterval
const AnimatedNumber = ({
  target,
  symbol,
}: {
  target: number;
  symbol?: string;
}) => {
  const [number, setNumber] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setNumber((prev) => {
        const next = prev + 1;
        if (next >= target) {
          clearInterval(interval);
          return target;
        }
        return next;
      });
    }, 20); // Adjust the speed by changing this interval

    return () => clearInterval(interval);
  }, [target]);

  return (
    <Typography variant="h4" sx={{ color: "#172554", fontWeight: "bold" }}>
      {number}
      {symbol}
    </Typography>
  );
};

const BlogSection: React.FC = () => {
  useScrollTransition();
  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: "1200px", margin: "auto" }}>
      {/* Animated Stats Section */}
      <Grid
      className="component"
        container
        spacing={2}
        justifyContent="center"
        sx={{ paddingTop: 2, paddingBottom: 2 }}
      >
        <Grid item xs={6} sm={3}>
          <Box textAlign="center">
            <AnimatedNumber target={10} symbol="+" />
            <Typography variant="subtitle1" sx={{ color: "#f97316" }}>
              Years Experience
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Box textAlign="center">
            <AnimatedNumber target={99} symbol="%" />
            <Typography variant="subtitle1" sx={{ color: "#f97316" }}>
              Accuracy Rate
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Box textAlign="center">
            <AnimatedNumber target={500} symbol="+" />
            <Typography variant="subtitle1" sx={{ color: "#f97316" }}>
              Positive Reviews
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Box textAlign="center">
            <AnimatedNumber target={600} symbol="+" />
            <Typography variant="subtitle1" sx={{ color: "#f97316" }}>
              Trusted Partners
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Features Section */}
      <Grid container spacing={3} direction="column" sx={{ mt: 5 }}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              margin: "20px 0px",
              gap: "10px",
              alignItems: "center",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img
              src="ma1.webp"
              alt="icon1"
              style={{ width: "80px", height: "80px" }}
              className="component"
            />
            <Box>
              <Typography variant="h6" color={"#172554"}className="component">
                Expert Writing Services
              </Typography>
              <Typography variant="body2" color={"black"} className="component">
                We offer professionally crafted dissertations, proposals, and
                other <br /> academic writings across diverse fields of study.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              margin: "20px 0px",
              gap: "10px",
              alignItems: "center",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img
              src="lp.webp"
              alt="icon2"
              style={{ width: "80px", height: "80px" }}
              className="component"
            />
            <Box>
              <Typography variant="h6" color={"#172554"} className="component">
                Setting New Standards
              </Typography>
              <Typography variant="body2" color={"black"} className="component">
                Our team consistently establishes new benchmarks in research,{" "}
                <br />
                helping students achieve groundbreaking results.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              margin: "20px 0px",
              gap: "10px",
              alignItems: "center",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img
              src="iot1.webp"
              alt="icon3"
              style={{ width: "80px", height: "80px" }}
              className="component"
            />
            <Box>
              <Typography variant="h6" color={"#172554"} className="component">
                Academic Documentation
              </Typography>
              <Typography variant="body2" color={"black"} className="component">
                We deliver meticulously structured academic documents, ensuring{" "}
                <br />
                your research is well-presented and impactful.
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BlogSection;
